
    const data = {"name":"src/core/icons/view-grid","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M3 11h8V3H3m0 18h8v-8H3m10 8h8v-8h-8m0-10v8h8V3\"/>","originalColors":[],"stopColors":[]}}

            export default data
            